import { withTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@mui/material';
import AppHeader from '@components/AppHeader';
import { useStyles } from './styles';
import { IOrientationOverlay, OrientationFromTo } from './interfaces';
import { DeviceOrientationIcon } from '@icons';
const OrientationOverlay = ({
  isButton,
  onClick,
  orientation,
  t: translate,
}: IOrientationOverlay) => {
  const classes = useStyles();
  return (
    <Box sx={classes.root}>
      <Box sx={classes.headerWrapper}>
        <AppHeader isAuthorized />
      </Box>
      <Box sx={classes.wrapper}>
        <Box component="div" sx={classes.iconWrapper(orientation)}>
          <DeviceOrientationIcon />
        </Box>
        <Typography sx={classes.title}>
          {translate('orientationScreen.title')}
        </Typography>
        <Box sx={classes.text}>
          <Typography sx={classes.subtitle}>
            {orientation === OrientationFromTo.LANDSCAPE_TO_PORTRAIT
              ? translate('orientationScreen.subtitleLandscapeToPortait')
              : translate('orientationScreen.subtitlePortraitToLandscape')}
          </Typography>
          <Typography sx={classes.message}>
            {translate('orientationScreen.message')}
          </Typography>
        </Box>
        {!!isButton && (
          <Button onClick={onClick} sx={classes.button}>
            {translate('continue')}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default withTranslation()(OrientationOverlay);
